import type { FaireProductEntity } from "../../entity_types/product";

export const p_nramhn9tpd: FaireProductEntity = {
  token: "p_nramhn9tpd",
  type: "product",
  name: "rocky's matcha Osada Ceremonial Blend Matcha 20g",
  brandToken: "b_jkddc7grcu",
  brandName: "rocky's matcha",
  imageUrl: "https://cdn.faire.com/fastly/cb58fea56bbd28236702c8e9c047aadd1c2af12cbd8de1282fcf26df8efb8416.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1621ec5d86975bc04bc1a9975c66522bbcbd3d7d28a8974fb831c15e64b0128b.jpeg",
    "https://cdn.faire.com/fastly/69d0377d33150936561fd971163a3515ff8c4edb27a989749315f712f7f077e7.png",
    "https://cdn.faire.com/fastly/d50b605e59b42de64f037f614763ba30ba72652ad661419403102d6f92a6e81e.jpeg"
  ],
  priceDollars: 12,
  description: "Introducing rocky’s matcha Osada Ceremonial Blend—an exclusive creation developed in partnership with Osada Tea. This custom-crafted matcha blend boasts a vibrant green color, silky texture, and subtly roasted flavor, making it an ideal choice for those new to matcha. Smooth and versatile, the Osada Ceremonial Blend is perfect for lattes and pairs beautifully with added sweeteners, offering a delightful balance of flavor for a range of preparations.\n\n\n\n+ Blended Matcha\n\n+ Ceremonial Grade\n\n+ Cultivars: Okumidori & Yutakamidori \n\n+ Region: Kagoshima, Miyazaki, & Shizuoka\n\n+ Net Weight: 20g\n",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-07T19:04:19.842Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
